<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleAdd">添加</el-button>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column align="center" label="ID" width="60">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.school.school_name }}
        </template>
      </el-table-column>
      <el-table-column label="广告图片" min-width="100" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.img" class="user-avatar">
        </template>
      </el-table-column>
      <el-table-column label="跳转类型" min-width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.link_type == 0">不跳转</span>
          <span v-else-if="scope.row.link_type == 1">领券中心</span>
          <span v-else-if="scope.row.link_type == 2">店铺</span>
          <span v-else-if="scope.row.link_type == 3">商品</span>
          <span v-else-if="scope.row.link_type == 4">外部链接</span>
        </template>
      </el-table-column>
      <el-table-column label="链接" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.link }}
        </template>
      </el-table-column>
      <el-table-column label="权重" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>
      <el-table-column label="是否上架" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.is_active == 0">下架</el-tag>
          <el-tag type="primary" v-else>上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="280" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-position="left" label-width="70px">
        <el-form-item label="图片" prop="name">
          <upload-one v-model="form.img"></upload-one>
          <div style="font-size:12px;color:red;">
            *推荐尺寸：750*380
          </div>
        </el-form-item>
        <el-form-item label="图片" prop="name">
          <el-select class="filter-item" v-model="form.link_type" placeholder="请选择跳转类型" style="width: 140px">
            <el-option label="不跳转" :value="0"></el-option>
            <el-option label="领券中心" :value="1"></el-option>
            <el-option label="店铺" :value="2"></el-option>
            <el-option label="商品" :value="3"></el-option>
            <el-option label="外部链接" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="form.link" placeholder="请输入链接" />
          <div style="line-height:16px;font-size: 12px;color:red;margin-top:10px;">
            <div>*店铺页面，此处填店铺id</div>
            <div>*商品页面，此处填商品id，只支持舍购商城的商品ID</div>
            <div>*外部链接，此处填链接url，需在支付宝小程序管理平台添加该业务域名</div>
          </div>
        </el-form-item>
        <el-form-item label="权重">
          <el-input type="number" v-model="form.weight" placeholder="权重越大越前排" />
        </el-form-item>
        <el-form-item label="是否上架">
          <el-switch v-model="form.is_active" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keyword: "",
        school_id: ""
      },
      dialogVisible: false,
      btnLoading: false,
      form: {
        id: "",
        img: "",
        link_type: 0,
        link: "",
        weight: 0,
        is_active: 1
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["schools", "school_id"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
    },
    dialogVisible(newVal, oldVal) {
      // 编辑框一异隐藏，马上清除旧数据
      if (newVal === false) {
        this.form = {
          id: "",
          img: "",
          link_type: 0,
          link: "",
          weight: 0,
          is_active: 1,
        };
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/banner/list",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleAdd() {
      this.dialogVisible = true;
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(item) {
      this.form = {
        id: item.id,
        img: item.img,
        link_type: item.link_type,
        link: item.link,
        weight: item.weight,
        is_active: item.is_active
      };
      this.dialogVisible = true;
    },
    handleDel(item) {
      this.$confirm("确定要删除该广告吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/banner/del",
          method: "get",
          params: {
            id: item.id
          }
        }).then(() => {
          // 删除最后一条数据时无数据问题
          this.list.length <= 1 ? this.listQuery.page-- : false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
      });
    },
    saveData() {
      if (!this.school_id) {
        this.$message({
          type: "warning",
          message: "请选择学校"
        });
        return;
      } else {
        this.form.school_id = this.school_id;
      }
      if (!this.form.img) {
        this.$message({
          type: "warning",
          message: "请上传图片"
        });
        return;
      }
      this.btnLoading = true;
      request({
        url: "/api/backend/banner/save",
        method: "post",
        data: this.form
      }).then(() => {
        this.btnLoading = false;
        this.dialogVisible = false;
        this.getList();
        this.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.floor-container {
  display: inline-block;
  width: 160px;
  height: 160px;
  margin-right: 25px;
  margin-bottom: 25px;
}
</style>
